import React from 'react';
import classlist from 'utils/classlist';
import './style.scss';

export interface MenuSwitchProps {
    opened: boolean;
    onClick: React.MouseEventHandler;
}

const MenuSwitch: React.FC<MenuSwitchProps> = ({ opened = false, onClick }) => {
    return (
        <div
            onClick={onClick}
            className={classlist('menu-switch-root', {
                'menu-switch-opened': opened
            })}>
            <span />
        </div>
    );
};

export default MenuSwitch;
